/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.20",
    versionName: "0.2.0-nightly.2025.10.20",
    versionChannel: "nightly",
    buildDate: "2025-10-20T00:07:56.279Z",
    commitHash: "6fda7613668e95bf62ca1a79c00eaac34f41751e",
};
